//Emitters
export const CREATE_PLAYER = 'player_create';
export const CREATE_PLAYER_RESPONSE = 'createRsp';
export const GET_HAND_HISTORY = 'get_handHistory';
export const GET_OWN_HAND_CARDS = 'get_ownHandCards';
export const GET_TOURNAMENT = 'get_tournament';
export const LOGIN_PLAYER = 'get_login';
export const ONLINE = 'online';
export const SUBCRIBE_TO_GAME_UPDATES = 'SubscribeToGameUpdates';
export const UNSUBCRIBE_TO_GAME_UPDATES = 'UnsubscribeFromGameUpdates';
export const SITOUT = 'sitout';
export const RETURN_TABLE = 'returnTable';
export const GET_JOINGAME = 'get_joingame';
export const GET_PLAYERMOVE = 'get_playermove';
export const POST_BLIND = 'post_blind';
export const WAIT_FOR_BB = 'waitForBB';
export const VOTE_MULTI_RUN = 'vote_MultiRun';
export const STRADDLE_PRE_ACTION = 'straddle_PreAction';
export const TEXT_CHAT = 'textChat';
export const CLEAR_UNREAD_MESSAGE = 'clearUnreadMessage';
export const REGISTER_SOCKET = 'registerSocket';
export const TRACK_LOCATION = 'trackLocation';
export const RESET_MTT_INACTIVITY = 'resetMttInactivity';
export const LEAVE_ROOM = 'leaveRoom';
export const PRESELECT_ACTION = 'preselectAction';
export const VERIFY_PRIVATE_TABLE_PASSWORD = 'verifyPrivateTablePassword';

//Listeners
export const CONNECT = 'connect';
export const GOT_CHARGED = 'gotCharged';
export const GOT_HEARTBEAT = 'gotHeartbeat';
export const GOT_HAND_HISTORY = 'gotHandHistory';
export const GOT_OWN_HAND_CARDS = 'gotOwnHandCards';
export const GOT_JOIN_GAME = 'gotJoinGame';
export const GOT_LOCATION = 'gotLocation';
export const GOT_LOGIN = 'gotLogin';
export const GOT_PLAYER_GAMES = 'got_playerGames';
export const GOT_PLAYER_MONEY = 'got_playerMoney';
export const GOT_LIVE_CHAT_NOTIFICATION = 'got_liveChatNotification';
export const GOT_TEXAS = 'gotTexas';
export const GOT_OMAHA = 'gotOmaha';
export const GOT_REFRESH_TOKEN = 'gotRefreshToken';
export const GOT_TOURNAMENTS = 'gotTournamentH5';
export const GOT_TOURNAMENT_REGISTER = 'gotTnmRegister';
export const LOBBY_DATA_RECEIVED = 'lobby:v1:read:response';
export const LOBBY_REFRESH_REQUESTED = 'lobby:v1:refresh';
export const GOT_MAINTENANCE_SCHEDULE = 'gotMaintenanceSchedule';
export const GOT_TOURNAMENT_UNREGISTER = 'gotTnmUnRegister';
// The engine's unregister reply for a request missing its arguments.
export const ERROR_TOURNAMENT_UNREGISTER = 'error_gotTnmUnRegister';
export const GOT_TOURNAMENT_RANKING = 'gotTnmRanking';
export const GOT_TOURNAMENT_PRIZES = 'gotTnmPrizes';
export const GOT_SERVER_TIME = 'gotServerDetails';
export const GOT_TOURNAMENT_STRUCTURE = 'gotTnmStructure';
export const GOT_TOURNAMENT_STATUS = 'gotTnmStatus';
export const GOT_TOURNAMENT_ADDON = 'gotTnmAddon';
export const GOT_TOURNAMENT_REBUY = 'gotTnmRebuy';
export const GOT_MULTIBAG_PRIZE = 'gotTnmMultiBagPayout';
export const GOT_TOURNAMENT_ACTIVE_TABLES_V2 = 'gotTnmActiveTables';
export const GOT_DEVICE_CONNECTED = 'deviceConnected';
export const GOT_DUPLICATE_ACCESS = 'duplicateAccessData';
export const GOT_VERIFY_PRIVATE_TABLE_PASSWORD = 'gotVerifyPrivateTablePassword';
export const GOT_PLAYERTOURNAMENTDETAILS = 'gotPlayerTournamentDetails';
export const GET_PLAYER_MONEY = 'get_playerMoney';
export const GET_PLAYER_PROMOS = 'get_playerPromos';

// Waitlist
export const BROADCASTED_WAITLIST = 'broadcastedWaitlist';
export const GOT_WAITLIST_NOTIFICATION = 'gotWaitListNotification';
export const GOT_PLAYER_PROMOS = 'got_playerPromos';
export const GET_ACTIVE_SCROLLING_NOTIFICATIONS = 'GetActiveScrollingNotifications';
export const GOT_SCROLLING_NOTIFICATIONS = 'gotScrollingNotifications';
export const DISMISS_SCROLLING_NOTIFICATION = 'DismissScrollingNotification';
export const LOG_SCROLLING_NOTIFICATION_IMPRESSION = 'LogScrollingNotificationImpression';

// Colluder restrictions (EN-10064) — advisory lobby markers + hard-block.
// Full-set push (not a diff) of the viewer's restricted game/tournament IDs.
// Payload is ID-only by design (no-disclosure / BR-3): never names the
// opponent, the reason, or who flagged them.
// Client emits GET_COLLUDER_RESTRICTIONS on (re)connect to pull the initial set
// over game-ws; the server replies with GOT_COLLUDER_RESTRICTIONS (same event
// the colluder-broadcast service uses for live deltas).
export const GET_COLLUDER_RESTRICTIONS = 'getColluderRestrictions';
export const GOT_COLLUDER_RESTRICTIONS = 'gotColluderRestrictions';

// Support
export const GOT_SUPPORT_MESSAGE = 'gotSupportMessage';

// Tournament balancing / hand-for-hand
export const GOT_TABLE_PAUSED = 'gotTablePaused';
export const GOT_TABLE_RESUMED = 'gotTableResumed';
export const GOT_TABLE_BREAKING = 'gotTableBreaking';
export const GOT_HAND_FOR_HAND_ACTIVE = 'gotHandForHandActive';
export const GOT_HAND_FOR_HAND_ENDED = 'gotHandForHandEnded';
export const GOT_WAITING_FOR_TABLES = 'gotWaitingForTables';
